export default "__VITE_ASSET__B4Ek3rCo__"